<template>
  <div class="container" v-async="loading">
    <div class="row">
      <div class="col-xs-12">
        <title-user>Ativar TAG</title-user>
        <div class="margin-t30">
          <div class="row row-fix content-box vehicles" v-if="vehicle">
            <div class="col-md-4 text-center">
              <div class="plate-box">
                <p class="cell-plate info-car">
                  <span data-v-214ba40a="">{{plate}}</span>
                </p>
              </div>
              <div class="tag-box">
                <p class="no-margin bold">TAG N°</p>
                <p class="no-margin">{{serial}}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="vehicle-box">
                <p class="no-margin bold">{{ vehicle.model.brand.name }}</p>
                <p class="no-margin bold">{{ vehicle.model.name | firstWord}}</p>
                <p class="no-margin three-dots">{{ vehicle.model.name | fromSecWord}}</p>
              </div>
            </div>
            <div class="col-md-5">
              <div class="margin-b20 alert" :class="errorClass" v-if="msg">
                <p>{{msg}}</p>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="margin-b20 alert" :class="errorClass" v-if="msg">
              <p>{{msg}}</p>
            </div>
          </div>
        </div>
        <button class="btn btn-primary btn-lg btn-xxl" onclick="Native.openScanner()">
          Escanear outro veículo
        </button>
        <i class="icon-marquee align-icon"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <router-link :to="{name: 'plans'}" tag="button" class="btn btn-back margin-t20">
          <i class="icon-circle-left align-icon-left"></i>
          Voltar
        </router-link>
      </div>
    </div>

  </div>
</template>
<style scoped lang="scss">
  .content-box.vehicles {
    margin: 10px 0;
  }
  .plate-box {
    float: left;
    margin: 25px 0 10px;
    text-align: center;
    width: 100px;
  }
  .tag-box {
    display: inline-block;
    line-height: 1.3;
    margin-top: 10px;
    text-align: center !important;
  }
  .vehicle-box {
    display: inline-block;
  }
  .vehicle-box p:nth-child(2) {
    font-size: 1.2em;
  }
  .alert {
    display: inline-block;
    margin-top: 12px;
    width: 100%;
  }
  .align-icon {
    position: relative;
    color: white;
    font-size: 2em;
    margin: -38px 15px 0 0;
    float: right;
  }
  @media screen and (max-width: 991px) {
    .plate-box {
      margin: 10px 0;
    }
    .tag-box {
      margin: 0;
    }
  }
</style>
<script>
import * as _ from 'lodash'
import moment from 'moment'
import vehicleService from '../../services/vehicles'
import ativarTagItem from './ativar-tag/ativar-tag-item.vue'
import tagService from '../../services/tag'
import MessageDialog from '../../components/message-dialog.vue'
import { EventBus } from '../../event-bus.js'


  export default {
    data(){
      return {
        loading: undefined,
        msg: undefined,
        vehicle: undefined,
        errorClass: ""
      }
    },
    watch:{
      $route: function(){
        this.activate();
      }
    },
    computed: {
      plate(){
        return this.$route.params.plate;
      },
      serial(){
        return this.$route.params.serial;
      }
    },
    created(){
      
    },
    mounted(){
      
      this.activate();
    },
    methods:{
      activate(){
        this.msg = undefined;
        this.loading = vehicleService.getVehiclesForActivate().then((responseVehicles) => {
          return responseVehicles.find(o => o.plate.replace('-', '') == this.plate.replace('-', ''))
        }).then( (v) => {
          this.vehicle = v;
          
          if(!v){
            this.msg = "Placa não dísponivel para ativação";
            this.errorClass = "alert-danger";
            return undefined;
          }
          let req = {
            serialNumber: this.serial,
            vehicleId :v.vehicleId
          };
          return tagService.activateTagSite(req).then( (resp) => {return resp});
        }).then(r => {
            
            if(r && r.status){
              this.msg = r.status.message;
              this.errorClass = r.status.code == 0 ? 'alert-success' : 'alert-error';
            }
        }).catch(error => {
          
          
          this.msg = error.data && error.data.status && error.data.status.message || 'Erro';
          this.errorClass = 'alert-danger';
        });

      }
    }
  }
</script>



// WEBPACK FOOTER //
// result-activate-tag.vue?1469bcd4